"use strict";

Shopify.theme.jsStoreSelectorTab = {
  init: function init($section) {

    // Add settings from schema to current object
    Shopify.theme.jsStoreSelectorTab = $.extend(this, Shopify.theme.getSectionData($section));
    this.$el = $('.store-selector-tab');

    // Sticky Store Selector Tab
    if (this.enable_sticky === true) {
      if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky == true) {
        this.enableSticky(0);
      }
      else{
        this.enableSticky();
      }

    } else {
      this.disableSticky();
    }
  },
  enableSticky: function enableSticky(offset) {
    // Add sticky functionality and recalculate offset for header sticky


    this.$el.parent().sticky({
      wrapperClassName: 'store-selector-tab-sticky-wrapper',
      zIndex: 40,
      topSpacing: offset || 0
    });
    this.resetHeader(this.$el.height());
  },
  disableSticky: function disableSticky() {
    // Remove sticky functionality and recalculate offset for header sticky
    this.$el.parent().unstick();
    this.resetHeader(0);
  },
  resetHeader: function resetHeader(offset) {
    if (Shopify.theme.jsHeader.enable_sticky === true && isScreenSizeLarge()) {
      if (Shopify.theme_settings.header_layout != 'vertical') {
        // Reset desktop sticky header
        Shopify.theme.jsHeader.disableSticky();
        Shopify.theme.jsHeader.enableSticky(offset);
      }
    } else if (Shopify.theme.jsHeader.enable_sticky === true && !isScreenSizeLarge()) {
      // Reset mobile sticky header
      Shopify.theme.mobileMenu.disableSticky();
      Shopify.theme.mobileMenu.enableSticky(offset);
    }
  },
  getStoreSelectorTabHeight: function getStoreSelectorTabHeight() {
    var storeSelectorTabHeight = $('.store-selector').outerHeight() || 0;
    return storeSelectorTabHeight;
  }
};